import { QueryHookOptions } from '@apollo/client';
import { useMemo } from 'react';

import {
  AudienceSelectItemsQuery,
  AudienceSelectItemsQueryVariables,
  useAudienceSelectItemsQuery,
} from '@occc/graphql';
import { useQuery } from '@occc-app/dataAccessLayer/utils';

type UseGetAudienceSelectItemsParams = {
  baseOptions?: QueryHookOptions<AudienceSelectItemsQuery, AudienceSelectItemsQueryVariables>;
  uuids?: string[];
  chainId?: string;
  skip?: boolean;
};

export const useGetAudienceSelectItemsByUuids = ({
  uuids,
  chainId,
  skip = false,
  baseOptions,
}: UseGetAudienceSelectItemsParams) => {
  const response = useQuery(useAudienceSelectItemsQuery, {
    ...baseOptions,
    skip: skip || !uuids?.length,
    variables: {
      ...baseOptions?.variables,
      first: uuids?.length ?? 0,
      filter: {
        ...baseOptions?.variables?.filter,
        uuidContains: uuids,
        ...(chainId ? { chainIdEquals: chainId } : {}),
      },
    },
  });

  const data = useMemo(() => {
    return response.data?.audiences.edges.map((e) => e.node);
  }, [response.data]);

  return useMemo(() => {
    return {
      ...response,
      data,
    };
  }, [data, response]);
};
